import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopNav } from "./TopNav";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { AskAiLauncher } from "@/components/help/AskAiLauncher";
import { useUIStore } from "@/store/uiStore";
import { cn } from "@/lib/utils";

export function AppShell() {
  const { sidebarOpen } = useUIStore();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.classList.add("dark");
    return () => {
      document.documentElement.classList.remove("dark");
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Ambient background glow */}
      <div
        aria-hidden
        className="fixed inset-0 -z-10 pointer-events-none bg-[radial-gradient(circle_at_top_right,hsl(var(--primary)/0.05),transparent_40%)]"
      />

      <Sidebar />

      <div className={cn("transition-all duration-200", sidebarOpen ? "lg:ml-64" : "lg:ml-16")}>
        <TopNav />
        <main className="p-6">
          <ErrorBoundary key={location.pathname}>
            <div key={location.pathname} className="animate-fade-in">
              <Outlet />
            </div>
          </ErrorBoundary>
        </main>
      </div>

      <AskAiLauncher />
    </div>
  );
}
